{#if $loading}

<div class="loading" >
    <div class="load_div">
        <div class="left"></div>
        <div class="right"></div>
        <div class="content">
            <h2>Loading</h2>Wait
        </div>
    </div>
</div>
{/if}

<script>
import { loading } from "../loader";


         
</script>